// extracted by mini-css-extract-plugin
export default {"transitioning":"📚19-10-2p4DKS"};